import { Vector2 } from "../../../common/vector2.js";
import { IController, StopBehavior } from "../types/controller_types.js";
import { InstanceBatch } from "../batching/instance_batch.js";

export class InstanceController implements IController
{
  private stable_ids: number[];
  
  private _is_stopped: boolean = false;
  public get is_stopped(): boolean { return this._is_stopped; }

  public getStableId(): number { return this.stable_ids[0]; }

  constructor( private batch: InstanceBatch, stable_id?: number | number[] ) 
  {
    if ( stable_id === undefined )
      this.stable_ids = [];
    else if ( Array.isArray( stable_id ) )
      this.stable_ids = [...stable_id];
    else
      this.stable_ids = [stable_id];
  }

  public addInstance( stable_id: number ): void
  {
    this.stable_ids.push( stable_id );
  }

  public addInstances( stable_ids: number[] ): void
  {
    this.stable_ids.push( ...stable_ids );
  }

  public cleanUp( is_alive_check: ( id: number ) => boolean ): void
  {
    this.stable_ids = this.stable_ids.filter( is_alive_check );
  }
  
  public stop( behavior: StopBehavior = StopBehavior.KeepInstances, fade_duration: number = 0 ): void
  {
    if ( this._is_stopped )
      return;
    this._is_stopped = true;

    const fade = behavior === StopBehavior.FadeInstances ? fade_duration : 0;
    
    for ( const id of this.stable_ids )
      this.batch.triggerDeath( id, performance.now(), fade );
  }

  public setPosition( pos: Vector2 ): void
  {
    for ( const id of this.stable_ids )
      this.batch.setInstancePosition( id, pos );
  }

  public setTransform( pos: Vector2, angle: number ): void
  {
    for ( const id of this.stable_ids )
      this.batch.setInstanceTransform( id, pos, angle );
  }

  public accelerate( factor: number, now: number ): void
  {
    for ( const id of this.stable_ids )
      this.batch.accelerateInstance( id, factor, now );
  }
}